import { MuiStylesType } from 'model/muiStyles.model';

const muiStyles: MuiStylesType = {
  content: {
    display: 'flex',
    padding: '20px 24px',
  },
};

export default muiStyles;
